const imageSet = {
  // product image for each product
  lensAccent: require('Images/new/lens/accent-style.png'),
  lensNatural: require('Images/new/lens/natural-shine.png'),
  lensBright: require('Images/new/lens/radiant-bright.png'),
  lensCharm: require('Images/new/lens/radiant-charm.png'),
  lensChic: require('Images/new/lens/radiant-chic.png'),
  lensSweet: require('Images/new/lens/radiant-sweet.png'),
  lensVivd: require('Images/new/lens/vivid-style.png'),
  lensRose: require('Images/new/lens/fresh-rose.png'),
  lensHoney: require('Images/new/lens/fresh-honey.png'),
  lensGrezel: require('Images/new/lens/fresh-grezel.png'),
  lensBlue: require('Images/new/lens/fresh-blue.png'),
  lensGreen: require('Images/new/lens/fresh-green.png'),
  lensHazel: require('Images/new/lens/fresh-hazel.png'),
  lensLilac: require('Images/new/lens/fresh-lenslilac.png'),
  lensLatte: require('Images/new/lens/fresh-lenslatte.png'),
  lensSheerAllure: require('Images/new/lens/sheer-allure.png'),
  lensSheerDream: require('Images/new/lens/sheer-dream.png'),

  //insertion
  wear: require('Images/insert/wear.png'),
  wash: require('Images/insert/wash.png'),
  remove: require('Images/insert/remove.png'),
  check: require('Images/insert/check.png'),

  //product content
  ac_big: require('Images/product/bigLens/ac.png'),
  ac_small: require('Images/product/smallLens/ac.png'),
  ac_small_th: require('Images/product/smallLens/ac_th.png'),
  ac_box: require('Images/new/lens_box/ac.png'),
  ac_box_zh: require('Images/new/lens_box/ac_ai_shan.png'),
  ac_small_zh: require('Images/new/small_lens/ac_china.png'),

  ns_big: require('Images/product/bigLens/ns.png'),
  ns_small: require('Images/product/smallLens/ns.png'),
  ns_small_th: require('Images/product/smallLens/ns_th.png'),
  ns_box: require('Images/new/lens_box/ns.png'),
  ns_box_zh: require('Images/new/lens_box/ns_xuan_shan.png'),
  ns_small_zh: require('Images/new/small_lens/ns_china.png'),

  rb_big: require('Images/product/bigLens/rb.png'),
  rb_small: require('Images/product/smallLens/rb.png'),
  rb_small_th: require('Images/product/smallLens/rb_th.png'),
  rb_box: require('Images/new/lens_box/rb.png'),
  rb_box_zh: require('Images/new/lens_box/rb_jing_xi.png'),
  rb_small_zh: require('Images/new/small_lens/rb_china.png'),

  rc_big: require('Images/product/bigLens/rc.png'),
  rc_small: require('Images/product/smallLens/rc.png'),
  rc_small_th: require('Images/product/smallLens/rc_th.png'),
  rc_box: require('Images/new/lens_box/rc.png'),
  rc_box_zh: require('Images/new/lens_box/rc_jing_qian.png'),
  rc_small_zh: require('Images/new/small_lens/rc_china.png'),

  rchic_big: require('Images/product/bigLens/rchic.png'),
  rchic_small: require('Images/product/smallLens/rchic.png'),
  rchic_small_th: require('Images/product/smallLens/rchic_th.png'),
  rchic_box: require('Images/new/lens_box/rchic.png'),
  rchic_box_zh: require('Images/new/lens_box/rchic_zong_hui_jin_se.png'),
  rchic_small_zh: require('Images/new/small_lens/rchic_china.png'),

  ms_big: require('Images/product/bigLens/ms.png'),
  ms_small: require('Images/product/smallLens/ms-small.png'),
  ms_box: require('Images/new/lens_box/ms-box.png'),


  rt_big: require('Images/product/bigLens/rt.png'),
  rt_small: require('Images/product/smallLens/rt-small.png'),
  rt_box: require('Images/new/lens_box/rt-box.png'),

  rs_big: require('Images/product/bigLens/rs.png'),
  rs_small: require('Images/product/smallLens/rs.png'),
  rs_small_th: require('Images/product/smallLens/rs_th.png'),
  rs_box: require('Images/new/lens_box/rs.png'),
  rs_box_zh: require('Images/new/lens_box/rs_jing_tian.png'),
  rs_small_zh: require('Images/new/small_lens/rs_china.png'),

  vi_big: require('Images/product/bigLens/vi.png'),
  vi_small: require('Images/product/smallLens/vi.png'),
  vi_small_th: require('Images/product/smallLens/vi_th.png'),
  vi_box: require('Images/new/lens_box/vi.png'),
  vi_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  vi_small_hk: require('Images/product/smallLens/vi_hk.png'),
  vi_small_zh: require('Images/new/small_lens/vi_china.png'),

  //TODO: add small and big size png for fresh honey and rose

  fr_big: require('Images/product/bigLens/fr.png'),
  fr_small: require('Images/product/smallLens/vi.png'),
  fr_small_3l: require('Images/product/smallLens/fr_3l.png'),
  fr_small_my: require('Images/product/smallLens/fr_my.png'),
  fr_box: require('Images/new/lens_box/vi.png'),
  fr_box_shot: require('Images/product/boxShots/Fresh_Pack_Rose_10.png'),
  fr_box_shot_30: require('Images/product/boxShots/Fresh_Pack_Rose_30.png'),
  fr_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  fr_small_hk: require('Images/product/smallLens/vi_hk.png'),
  fr_small_zh: require('Images/new/small_lens/vi_china.png'),
  fr_box_shot_emea: require('Images/product/boxShots/Fresh_Pack_Rose3_Side.png'),
  fr_small_arabia_en: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-ROSE-eng.png'),
  fr_small_arabia: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-ROSE.png'),
  fr_small_ru: require('Images/product/smallLens/Acuvue_DEFINE_Small_Color_6507-01.png'),

  fh_big: require('Images/product/bigLens/fh.png'),
  fh_big_my: require('Images/product/bigLens/fh_my.png'),
  fh_small: require('Images/product/smallLens/vi.png'),
  fh_small_3l: require('Images/product/smallLens/fh_3l.png'),
  fh_small_my: require('Images/product/smallLens/fh_my.png'),
  fh_small_th: require('Images/product/smallLens/fh_th.png'),
  fh_small_vn: require('Images/product/smallLens/fh_vn.png'),
  fh_box: require('Images/new/lens_box/vi.png'),
  fh_box_shot: require('Images/product/boxShots/Fresh_Pack_Honey_10.png'),
  fh_box_shot_30: require('Images/product/boxShots/Fresh_Pack_Honey_30.png'),
  fh_box_shot_30_side: require('Images/product/boxShots/Fresh_Pack_Honey_30_side.png'),
  fh_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  fh_small_hk: require('Images/product/smallLens/vi_hk.png'),
  fh_small_zh: require('Images/new/small_lens/vi_china.png'),
  fh_box_shot_emea: require('Images/product/boxShots/Fresh_Pack_Honey3_Side.png'),
  fh_small_arabia_en: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-Honey-eng.png'),
  fh_small_arabia: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-Honey.png'),

  fg_big: require('Images/product/bigLens/fg.png'),
  fg_big_my: require('Images/product/bigLens/fg_my.png'),
  fg_small: require('Images/product/smallLens/vi.png'),
  fg_small_3l: require('Images/product/smallLens/fg_3l.png'),
  fg_small_th: require('Images/product/smallLens/fg_th.png'),
  fg_small_my: require('Images/product/smallLens/fg_my.png'),
  fg_small_vn: require('Images/product/smallLens/fg_vn.png'),
  fg_box: require('Images/new/lens_box/vi.png'),
  fg_box_shot: require('Images/product/boxShots/Fresh_Pack_Grayzel_10.png'),
  fg_box_shot_30: require('Images/product/boxShots/Fresh_Pack_Grayzel_30.png'),
  fg_box_shot_30_side: require('Images/product/boxShots/Fresh_Pack_Grayzel_30_side.png'),
  fg_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  fg_small_hk: require('Images/product/smallLens/vi_hk.png'),
  fg_small_zh: require('Images/new/small_lens/vi_china.png'),
  fg_box_shot_emea: require('Images/product/boxShots/Fresh_Pack_Grayzel3_Side.png'),
  fg_small_arabia_en: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-GRAYZEL-eng.png'),
  fg_small_arabia: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-GRAYZEL.png'),
  fg_small_ru: require('Images/product/smallLens/Acuvue_DEFINE_Small_Color_6507-03.png'),

  fb_big: require('Images/product/bigLens/fb.png'),
  fb_big_my: require('Images/product/bigLens/fb_my.png'),
  fb_small: require('Images/product/smallLens/vi.png'),
  fb_small_3l: require('Images/product/smallLens/fb_3l.png'),
  fb_small_my: require('Images/product/smallLens/fb_my.png'),
  fb_box: require('Images/new/lens_box/vi.png'),
  fb_box_shot: require('Images/product/boxShots/Fresh_Pack_Blue_10.png'),
  fb_box_shot_30: require('Images/product/boxShots/Fresh_Pack_Blue_30.png'),
  fb_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  fb_small_hk: require('Images/product/smallLens/vi_hk.png'),
  fb_small_zh: require('Images/new/small_lens/vi_china.png'),
  fb_box_shot_emea: require('Images/product/boxShots/Fresh_Pack_Blue3_Side.png'),
  fb_small_arabia_en: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-BLUE-eng.png'),
  fb_small_arabia: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-BLUE.png'),
  fb_small_ru: require('Images/product/smallLens/Acuvue_DEFINE_Small_Color_6507-04.png'),

  flc_big: require('Images/product/bigLens/fresh-lenslilac.png'),
  flc_small: require('Images/product/smallLens/flc.png'),
  flc_box_shot: require('Images/product/boxShots/Fresh_Pack_lilac_Front_10.png'),
  flc_box_shot_30: require('Images/product/boxShots/Fresh_Pack_lilac_Front_30.png'),

  fle_big: require('Images/product/bigLens/fresh-lenslatte.png'),
  fle_small: require('Images/product/smallLens/fle.png'),
  fle_box_shot: require('Images/product/boxShots/Fresh_Pack_latte_Front_10.png'),
  fle_box_shot_30: require('Images/product/boxShots/Fresh_Pack_latte_Front_30.png'),

  fgn_big: require('Images/product/bigLens/fgn.png'),
  fgn_big_my: require('Images/product/bigLens/fgn_my.png'),
  fgn_small: require('Images/product/smallLens/vi.png'),
  fgn_small_3l: require('Images/product/smallLens/fgn_3l.png'),
  fgn_small_th: require('Images/product/smallLens/fg_th.png'),
  fgn_small_my: require('Images/product/smallLens/fgn_my.png'),
  fgn_box: require('Images/new/lens_box/vi.png'),
  fgn_box_shot: require('Images/product/boxShots/Fresh_Pack_Grayzel_10.png'),
  fgn_box_shot_30: require('Images/product/boxShots/Fresh_Pack_Green_30.png'),
  fgn_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  fgn_small_hk: require('Images/product/smallLens/vi_hk.png'),
  fgn_small_zh: require('Images/new/small_lens/vi_china.png'),
  fgn_box_shot_emea: require('Images/product/boxShots/Fresh_Pack_Green3_Side.png'),
  fgn_big_emea: require('Images/product/bigLens/Fresh_Green_Lens.png'),
  fgn_small_arabia_en: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-green-eng.png'),
  fgn_small_arabia: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-green.png'),
  fgn_small_ru: require('Images/product/smallLens/Acuvue_DEFINE_Small_Color_6507-02.png'),

  fhl_big: require('Images/product/bigLens/fhl.png'),
  fhl_small: require('Images/product/smallLens/vi.png'),
  fhl_small_3l: require('Images/product/smallLens/fhl_3l.png'),
  fhz_small: require('Images/product/smallLens/fhz-small-th.png'),
  fhl_small_my: require('Images/product/smallLens/fhl_my.png'),
  fhl_small_th: require('Images/product/smallLens/fg_th.png'),
  fhl_box: require('Images/new/lens_box/vi.png'),
  fhl_box_shot: require('Images/product/boxShots/Fresh_Pack_Hazel_10.png'),
  fhl_box_shot_30: require('Images/product/boxShots/Fresh_Pack_Hazel_30.png'),
  fhl_box_zh: require('Images/new/lens_box/vi_yan_yan.png'),
  fhl_small_hk: require('Images/product/smallLens/vi_hk.png'),
  fhl_small_zh: require('Images/new/small_lens/vi_china.png'),
  fhl_box_shot_emea: require('Images/product/boxShots/Fresh_Pack_Hazel3_Side.png'),
  fhl_big_emea: require('Images/product/bigLens/Fresh_Hazel_Lens.png'),
  fhl_small_arabia_en: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-HAZEL-eng.png'),
  fhl_small_arabia: require('Images/product/smallLens/Virtual-mirror-lens-4-psd_Fresh-HAZEL.png'),

  lsa_big: require('Images/product/bigLens/lsa.png'),
  lsa_box: require('Images/new/lens_box/lsa_box.png'),
  lsd_big: require('Images/product/bigLens/lsd.png'),
  lsd_box: require('Images/new/lens_box/lsd_box.png'),

  //External images
  //External buy image
  external_buy_standard: require('Images/new/shop_icons/cart_logo.png'),
  external_buy_tw: require('Images/new/shop_icons/cart_logo_tw.png'),
  //External cart image
  external_cart_standard: require('Images/new/shop_icons/cart_logo.png'),
  //Buy Product cart image
  external_buy_standard: require('Images/new/shop_icons/cart_logo.png'),

  //product tutorial image specifically needed for Korea region
  // add images for tutorial of rest of the fresh lenses for Korea region
  rchic_tutorial: require('Images/new/product_tutorial_korea/Lens-Radiant Chic.png'),
  rs_tutorial: require('Images/new/product_tutorial_korea/Lens-Radiant Sweet.png'),
  rb_tutorial: require('Images/new/product_tutorial_korea/Lens-Radiant Bright.png'),
  rc_tutorial: require('Images/new/product_tutorial_korea/Lens-Radiant Charm.png'),
  ns_tutorial: require('Images/new/product_tutorial_korea/Lens-Natural Shine.png'),
  vi_tutorial: require('Images/new/product_tutorial_korea/Lens-Vivid Style.png'),
  as_tutorial: require('Images/new/product_tutorial_korea/Lens-Accent Style.png'),
  fr_tutorial: require('Images/new/product_tutorial_korea/Lens-Fresh Rose.png'),
  fh_tutorial: require('Images/new/product_tutorial_korea/Lens-Fresh Honey.png'),
  fb_tutorial: require('Images/new/product_tutorial_korea/Lens-Fresh Blue.png'),
  fg_tutorial: require('Images/new/product_tutorial_korea/Lens-Fresh Grayzel.png'),
  fgn_tutorial: require('Images/new/product_tutorial_korea/Lens-Fresh Green.png'),
  fhl_tutorial: require('Images/new/product_tutorial_korea/Lens-Fresh Hazel.png'),

  rchic_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Chic_HK.png'),
  rs_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Sweet_HK.png'),
  rb_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Bright_HK.png'),
  rc_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Charm_HK.png'),
  ns_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-NS_HK.png'),
  vi_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Vivid_HK.png'),
  as_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Accent_HK.png'),
  fr_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Rose_HK.png'),
  fh_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Honey_HK.png'),
  fg_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Grayzel_HK.png'),
  fb_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Blue_HK.png'),
  fgn_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Green_HK.png'),
  fhl_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Hazel_HK.png'),
  flc_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Lilac_HK.png'),
  fle_tutorial_hk: require('Images/new/product_tutorial_hongkong/Lens-Fresh_Latte_HK.png'),

  rchic_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Chic_TW.png'),
  rs_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Sweet_TW.png'),
  rb_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Bright_TW.png'),
  rc_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Charm_TW.png'),
  ns_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-NS_TW.png'),
  vi_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Vivid_TW.png'),
  as_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Accent_TW.png'),
  fr_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Fresh_Rose_TW.png'),
  fh_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Fresh_Honey_TW.png'),
  fg_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Fresh_Grayzel_TW.png'),
  fb_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Fresh_Blue_TW.png'),
  fgn_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Fresh_Green_TW.png'),
  fhl_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Fresh_Hazel_TW.png'),
  fhlc_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Lilac_TW.png'),
  fhle_tutorial_tw: require('Images/new/product_tutorial_tw/Lens-Latte_TW.png'),


  //product diameter image specifically needed for Korea region
  // add images for diameter of rest of the fresh lenses for Korea region
  rchic_diameter: require('Images/new/product_diameter/Lens-Radiant Chic_diameter.png'),
  rs_diameter: require('Images/new/product_diameter/Lens-Radiant Sweet_diameter.png'),
  rb_diameter: require('Images/new/product_diameter/Lens-Radiant Bright_diameter.png'),
  rc_diameter: require('Images/new/product_diameter/Lens-Radiant Charm_diameter.png'),
  ns_diameter: require('Images/new/product_diameter/Lens-Natural Shine_diameter.png'),
  vi_diameter: require('Images/new/product_diameter/Lens-Vivid Style_diameter.png'),
  as_diameter: require('Images/new/product_diameter/Lens-Accent Style_diameter.png'),
  fr_diameter: require('Images/new/product_diameter/Lens-Fresh Rose_diameter.png'),
  fh_diameter: require('Images/new/product_diameter/Lens-Fresh Honey_diameter.png'),
  fg_diameter: require('Images/new/product_diameter/Lens-Fresh Gray_diameter.png'),
  fgn_diameter: require('Images/new/product_diameter/Lens-Fresh Green_diameter.png'),
  fhl_diameter: require('Images/new/product_diameter/Lens-Fresh Hazel_diameter.png'),

  //product icons
  package_icon: require('Images/product_icon/package_icon.png'),
  lens_diameter_icon: require('Images/product_icon/lens_diameter_icon.png'),
  base_curves_icon: require('Images/product_icon/base_curves_icon.png'),
  power_icon: require('Images/product_icon/power_icon.png'),
  breathability_icon: require('Images/product_icon/breathability_icon.png'),
  smoothness_icon: require('Images/product_icon/smoothness_icon.png'),
  uv_icon: require('Images/product_icon/uv_icon.png'),
  wettability_icon: require('Images/product_icon/wettability_icon.png'),
  ThumbsUp_Icon: require('Images/product_icon/ThumbsUp_Icon.png'),

  //square
  '1_square': require('Images/color_square/1_square.png'),
  '2_square': require('Images/color_square/2_square.png'),
  '3_square': require('Images/color_square/3_square.png'),
  '4_square': require('Images/color_square/4_square.png'),
  '5_square': require('Images/color_square/5_square.png'),
  '6_square': require('Images/color_square/6_square.png'),

  //skin square
  ac_square: require('Images/color_square/ac_square.png'),
  bw_square: require('Images/color_square/bw_square.png'),
  cc_square: require('Images/color_square/cc_square.png'),
  ew_square: require('Images/color_square/ew_square.png'),
  dw_square: require('Images/color_square/dw_square.png'),
  fc_square: require('Images/color_square/fc_square.png'),

  // stars
  rs_star: require('Images/new/stars/star-rs.png'),
  rc_star: require('Images/new/stars/star-rc.png'),
  as_star: require('Images/new/stars/star-as.png'),
  ns_star: require('Images/new/stars/star-ns.png'),
  rb_star: require('Images/new/stars/star-rb.png'),
  vi_star: require('Images/new/stars/star-vi.png'),
  rchic_star: require('Images/new/stars/star-rchic.png'),
  fr_star: require('Images/new/stars/star-fr.png'),
  fh_star: require('Images/new/stars/star-fh.png'),
  fg_star: require('Images/new/stars/star-fg.png'),
  fb_star: require('Images/new/stars/star-fb.png'),
  fgn_star: require('Images/new/stars/star-fg.png'),
  fhl_star: require('Images/new/stars/star-fha.png'),
  lsa_star: require('Images/new/stars/star-lsa.png'),
  lsd_star: require('Images/new/stars/star-lsd.png'),
  icon_star: require('Images/icon-star.png'),

  //looks
  captivating: require('Images/new/looks/captivating.png'),
  enchanting: require('Images/new/looks/enchanting.png'),
  elegant: require('Images/new/looks/elegant.png'),
  illuminate: require('Images/new/looks/illuminate.png'),
  innocent: require('Images/new/looks/innocent.png'),
  sophisticated: require('Images/new/looks/sophisticated.png'),
  vibrant: require('Images/new/looks/vibrant.png'),

  //looks_tutorials
  look_elegant: require('Images/new/looks_tutorials/elegant/elegant-thumbnail.png'),
  look_elegant_step_1: require('Images/new/looks_tutorials/elegant/elegant-1.png'),
  look_elegant_step_2: require('Images/new/looks_tutorials/elegant/elegant-2.png'),
  look_elegant_step_3: require('Images/new/looks_tutorials/elegant/elegant-3.png'),
  look_elegant_step_4: require('Images/new/looks_tutorials/elegant/elegant-4.png'),
  look_innocent: require('Images/new/looks_tutorials/innocent/innocent-thumbnail.png'),
  look_innocent_step_1: require('Images/new/looks_tutorials/innocent/innocent-1.png'),
  look_innocent_step_2: require('Images/new/looks_tutorials/innocent/innocent-2.png'),
  look_innocent_step_3: require('Images/new/looks_tutorials/innocent/innocent-3.png'),
  look_innocent_step_4: require('Images/new/looks_tutorials/innocent/innocent-4.png'),
  look_vibrant: require('Images/new/looks_tutorials/vibrant/vibrant-thumbnail.png'),
  look_vibrant_step_1: require('Images/new/looks_tutorials/vibrant/vibrant-1.png'),
  look_vibrant_step_2: require('Images/new/looks_tutorials/vibrant/vibrant-2.png'),
  look_vibrant_step_3: require('Images/new/looks_tutorials/vibrant/vibrant-3.png'),
  look_vibrant_step_4: require('Images/new/looks_tutorials/vibrant/vibrant-4.png'),
  look_illuminate: require('Images/new/looks_tutorials/illuminate/illuminate-thumbnail.png'),
  look_illuminate_step_1: require('Images/new/looks_tutorials/illuminate/illuminate-1.png'),
  look_illuminate_step_2: require('Images/new/looks_tutorials/illuminate/illuminate-2.png'),
  look_illuminate_step_3: require('Images/new/looks_tutorials/illuminate/illuminate-3.png'),
  look_captivating: require('Images/new/looks_tutorials/captivating/captivating-thumbnail.png'),
  look_captivating_step_1: require('Images/new/looks_tutorials/captivating/captivating-1.png'),
  look_captivating_step_2: require('Images/new/looks_tutorials/captivating/captivating-2.png'),
  look_captivating_step_3: require('Images/new/looks_tutorials/captivating/captivating-3.png'),
  look_captivating_step_4: require('Images/new/looks_tutorials/captivating/captivating-4.png'),
  look_enchanting: require('Images/new/looks_tutorials/enchanting/enchanting-thumbnail.png'),
  look_enchanting_step_1: require('Images/new/looks_tutorials/enchanting/enchanting-1.png'),
  look_enchanting_step_2: require('Images/new/looks_tutorials/enchanting/enchanting-2.png'),
  look_enchanting_step_3: require('Images/new/looks_tutorials/enchanting/enchanting-3.png'),
  look_enchanting_step_4: require('Images/new/looks_tutorials/enchanting/enchanting-4.png'),
  look_sophisticated: require('Images/new/looks_tutorials/sophisticated/sophisticated-thumbnail.png'),
  look_sophisticated_step_1: require('Images/new/looks_tutorials/sophisticated/sophisticated-1.png'),
  look_sophisticated_step_2: require('Images/new/looks_tutorials/sophisticated/sophisticated-2.png'),
  look_sophisticated_step_3: require('Images/new/looks_tutorials/sophisticated/sophisticated-3.png'),
  look_sophisticated_step_4: require('Images/new/looks_tutorials/sophisticated/sophisticated-4.png'),
  // Homepage cards
  en_card_model: require('Images/new/Lens_Card.png'),
  en_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  en_card_promo: require('Images/new/Promotion_Card_SG.jpg'),
  sg_card_model: require('Images/new/Lens_Card.png'),
  sg_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  sg_card_promo: require('Images/new/Promotion_Card_SG.jpg'),
  zh_card_model: require('Images/new/Lens_Card_CN.png'),
  zh_card_quiz: require('Images/new/Quiz_Card.png'),
  zh_card_promo: require('Images/new/Promotion_Card_CN.png'),
  ja_card_model: require('Images/new/Lens_Card_JP_new.png'),
  ja_card_quiz: require('Images/new/Quiz_Card_JP.jpg'),
  ja_card_promo: require('Images/new/Promotion_Card_JP.jpg'),
  my_card_model: require('Images/new/Lens_Card.png'),
  my_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  my_card_promo: require('Images/new/Promotion_Card_MY.jpg'),
  ko_card_model: require('Images/new/Lens_Card_KO.jpg'),
  ko_card_quiz: require('Images/new/Quiz_Card_KO.jpg'),
  ko_card_promo: require('Images/new/Promotion_Card.png'),
  th_card_model: require('Images/new/Lens_Card.png'),
  th_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  th_card_promo: require('Images/new/Promotion_Card_TH.jpg'),
  th_card_promo_small: require('Images/new/Promotion_Card_TH_Small.jpg'),
  az_card_model: require('Images/new/Lens_Card.png'),
  az_card_quiz: require('Images/new/Quiz_Card_Big.png'),
  az_card_promo: require('Images/new/Promotion_Card.png'),
  hk_card_model: require('Images/new/Lens_Card.png'),
  hk_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  hk_card_promo: require('Images/new/Promotion_Card_HK.png'),
  id_card_model: require('Images/new/Lens_Card.png'),
  id_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  id_card_promo: require('Images/new/Promo_Card_ID.jpg'),
  twq_card_model: require('Images/new/Lens_Card.png'),
  twq_card_quiz: require('Images/new/Quiz_Card_With_Text.png'),
  twq_card_promo: require('Images/new/Promotion_Card.png'),

  // makeup
  blush: require('Images/new/makeup/blush.png'),
  lipstick: require('Images/new/makeup/lipstick.png'),
  eyeliner: require('Images/new/makeup/eyeliner.png'),
  eyeshadow: require('Images/new/makeup/eyeshadow.png'),
  lipcolors: require('Images/new/makeup/lipstick.png'),
  eyelashes: require('Images/new/makeup/eyelashes.png'),

  instagram_th_fh: require('Images/product/instagram/Fresh_Honey_TH.png'),
  instagram_th_fh2: require('Images/product/instagram/Fresh_Honey_TH2.png'),
  instagram_th_fg: require('Images/product/instagram/Fresh_Grazel_TH.png'),
  instagram_th_fg2: require('Images/product/instagram/Fresh_Grazel_TH2.png'),
  instagram_th_fr: require('Images/product/instagram/Fresh_Rose_TH.png'),
  instagram_th_fr2: require('Images/product/instagram/Fresh_Rose_TH2.png'),
  instagram_th_fb: require('Images/product/instagram/Fresh_Blue_TH.png'),
  instagram_th_fb2: require('Images/product/instagram/Fresh_Blue_TH2.png'),

  instagram_refresh_lens: require('Images/newUi/refresh.png'),
  instagram_refresh_effect: require('Images/newUi/refresh_effect.png'),

  // float button
  twFloatButton: require('Images/new/float_button/float_button_tw.png'),
  jpFloatButton: require('Images/new/float_button/float_button_jp.png'),

  // lens removal
  ensure: require('Images/new/removal/ensure.png'),
  bring: require('Images/new/removal/bring.png'),
  squeeze: require('Images/new/removal/squeeze.png'),
  discard: require('Images/new/removal/discard.png'),

  // color pallete
  color_pallete_enchanting: require('Images/new/looks_tutorials/enchanting/enchanting-color-pallete.png'),
  color_pallete_sophisticated: require('Images/new/looks_tutorials/sophisticated/sophisticated-color-pallete.png'),
  color_pallete_vibrant: require('Images/new/looks_tutorials/vibrant/vibrant-color-pallete.png'),
  color_pallete_elegant: require('Images/new/looks_tutorials/elegant/elegant-color-pallete.png'),
  color_pallete_illuminate: require('Images/new/looks_tutorials/illuminate/illuminate-color-pallete.png'),
  color_pallete_captivating: require('Images/new/looks_tutorials/captivating/captivating-color-pallete.png'),
  color_pallete_innocent: require('Images/new/looks_tutorials/innocent/innocent-color-pallete.png'),

  // Eyelashes
  eyelash01: require('Images/new/eyelash01.png'),
  eyelash03: require('Images/new/eyelash03.png'),
  eyelash05: require('Images/new/eyelash05.png'),
  eyelash06: require('Images/new/eyelash06.png'),
  eyelash08: require('Images/new/eyelash08.png'),

  // Quiz options
  quiz_1_a: require('Images/new/quiz/1-a.png'),
  quiz_1_b: require('Images/new/quiz/1-b.png'),
  quiz_1_c: require('Images/new/quiz/1-c.png'),
  quiz_1_d: require('Images/new/quiz/1-d.png'),
  quiz_2_a: require('Images/new/quiz/2-a.png'),
  quiz_2_b: require('Images/new/quiz/2-b.png'),
  quiz_2_c: require('Images/new/quiz/2-c.png'),
  quiz_2_d: require('Images/new/quiz/2-d.png'),
  quiz_3_a: require('Images/new/quiz/3-a.png'),
  quiz_3_b: require('Images/new/quiz/3-b.png'),
  quiz_3_c: require('Images/new/quiz/3-c.png'),
  quiz_3_d: require('Images/new/quiz/3-d.png'),
  quiz_4_a: require('Images/new/quiz/4-a.jpg'),
  quiz_4_b: require('Images/new/quiz/4-b.jpg'),
  quiz_4_c: require('Images/new/quiz/4-c.jpg'),
  quiz_4_d: require('Images/new/quiz/4-d.jpg'),
  quiz_5_a: require('Images/new/quiz/5-a.jpg'),
  quiz_5_b: require('Images/new/quiz/5-b.jpg'),
  quiz_5_c: require('Images/new/quiz/5-c.jpg'),
  quiz_5_d: require('Images/new/quiz/5-d.jpg'),

  // Results
  type_a: require('Images/new/quiz/type_a.png'),
  type_a_id: require('Images/new/quiz/type_a_id.png'),
  type_b: require('Images/new/quiz/type_b.png'),
  type_b_id: require('Images/new/quiz/type_b_id.png'),
  type_c: require('Images/new/quiz/type_c.png'),
  type_c_id: require('Images/new/quiz/type_c_id.png'),
  type_d: require('Images/new/quiz/type_d.png'),
  type_d_id: require('Images/new/quiz/type_d_id.png'),
  result_as: require('Images/new/quiz/lens_as.png'),
  result_ns: require('Images/new/quiz/lens_ns.png'),
  result_vi: require('Images/new/quiz/lens_vi.png'),
  result_rs: require('Images/new/quiz/lens_rs.png'),
  result_rb: require('Images/new/quiz/lens_rb.png'),
  result_rc: require('Images/new/quiz/lens_rc.png'),
  result_rchic: require('Images/new/quiz/lens_rchic.png'),
  result_as_ja: require('Images/new/quiz/result_as_ja.jpg'),
  result_ns_ja: require('Images/new/quiz/result_ns_ja.jpg'),
  result_vi_ja: require('Images/new/quiz/result_vi_ja.jpg'),
  result_rs_ja: require('Images/new/quiz/result_rs_ja.jpg'),
  result_rb_ja: require('Images/new/quiz/result_rb_ja.jpg'),
  result_rc_ja: require('Images/new/quiz/result_rc_ja.jpg'),
  result_rchic_ja: require('Images/new/quiz/result_rchic_ja.jpg'),
  result_fb_ja: require('Images/new/quiz/result_fb_ja.jpg'),
  result_fb_id: require('Images/new/quiz/result_fb_id.jpg'),
  result_fr_ja: require('Images/new/quiz/result_fr_ja.jpg'),
  result_fg_ja: require('Images/new/quiz/result_fg_ja.jpg'),
  result_fg_id: require('Images/new/quiz/result_fg_id.jpg'),
  result_fh_ja: require('Images/new/quiz/result_fh_ja.jpg'),
  result_fh_id: require('Images/new/quiz/result_fh_id.jpg'),
  result_fhl_id: require('Images/new/quiz/result_fhl_id.jpg'),
  result_fhl_ja: require('Images/new/quiz/result_fhl_ja.jpg'),
  result_lsa_ja: require('Images/new/quiz/result_lsa_ja.png'),
  result_lsd_ja: require('Images/new/quiz/result_lsd_ja.png'),
};

export { imageSet };
